export default {
  name: 'rb-dynamic-grid-stella-product',
  props: {
    index: {
      type: Number,
      default: 0,
    },
    totalOfSlides: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    renderSlide(createElement, columnSize) {
      const filteredSlots = this.$slots.default.filter((slot) => !!slot.tag)
      const currentSlot = filteredSlots[this.index]
      return createElement('div', { class: columnSize }, [currentSlot])
    },
  },
  render(createElement) {
    return this.renderSlide(createElement, 'col-6')
  },
}
